import React from 'react';
import { useTranslation } from 'react-i18next';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import NetworkBarItem from '../NetworkBarItem';
var NetworkBarLink = function (_a) {
    var label = _a.label, Icon = _a.icon, url = _a.url, tabIndex = _a.tabIndex, isSelected = _a.isSelected, isCollapsed = _a.isCollapsed, hasNewContent = _a.hasNewContent, betaBadge = _a.betaBadge, className = _a.className, menuItems = _a.menuItems, showTooltip = _a.showTooltip;
    var t = useTranslation().t;
    return (React.createElement(NetworkBarItem, { url: url, tooltipContent: t("networkBar.navItems.".concat(label, ".tooltip")), icon: React.createElement(Icon, { disableDefaultColors: true, size: IconSize.MEDIUM }), biData: {
            evid: BiEventType.NETWORK_BAR_NAV_CLICK,
            sectionname: label,
            indicator: hasNewContent ? 1 : 0,
            is_expanded: isCollapsed ? 0 : 1,
        }, menuBiData: {
            evid: BiEventType.NETWORK_BAR_3DOTS_OPEN,
            sectionname: label,
            indicator: hasNewContent ? 1 : 0,
        }, isSelected: isSelected, isCollapsed: isCollapsed, hasNewContent: hasNewContent, betaBadge: betaBadge, tabIndex: tabIndex, menuItems: menuItems, className: className, showTooltip: showTooltip, "aria-label": t("networkBar.navItems.".concat(label)) }, t("networkBar.navItems.".concat(label))));
};
NetworkBarLink.displayName = 'NetworkBarLink';
export default NetworkBarLink;
//# sourceMappingURL=NetworkBarLink.js.map